import React from 'react';
import { BreakdownFooter, Footer, Header } from 'Components';
import { Outlet } from 'react-router-dom';
import { useAppContext } from 'Contexts';

export const App: React.FC = () => {
  const { newFontDisplayed, origin } = useAppContext();
  const isBreakdownTunnel = origin === 'breakdown';
  return (
    <div className={`bg-whitesmoke min-h-screen flex flex-col justify-between${newFontDisplayed ? ' new-fonts' : ''}`}>
      <Header />

      <Outlet />

      {isBreakdownTunnel ? <BreakdownFooter /> : <Footer />}
    </div>
  );
};
